var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5543_13421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5029 20.0469C30.9423 20.0469 30.4873 20.5019 30.4873 21.0625C30.4873 21.6231 30.9423 22.0781 31.5029 22.0781C32.0636 22.0781 32.5186 21.6231 32.5186 21.0625C32.5186 20.5019 32.0636 20.0469 31.5029 20.0469Z",
    fill: "url(#paint0_linear_5543_13421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8283 45.8152L37.2718 32.2586C39.4803 28.9321 40.6436 25.0798 40.6436 21.0625C40.6436 9.86219 31.5314 0.75 20.3311 0.75C9.13074 0.75 0.0185547 9.86219 0.0185547 21.0625C0.0185547 32.2628 9.13074 41.375 20.3311 41.375C24.3485 41.375 28.2007 40.2116 31.5272 38.0033L35.2744 41.7505C35.2749 41.751 35.2754 41.7515 35.276 41.7521L45.0837 51.5598C45.8513 52.3273 46.8713 52.75 47.9561 52.75C49.0408 52.75 50.0608 52.3273 50.828 51.5601C51.5958 50.793 52.0186 49.7729 52.0186 48.6875C52.0186 47.6021 51.5957 46.582 50.8283 45.8152ZM31.0496 35.8629L31.0494 35.8631C27.9144 38.1401 24.2082 39.3438 20.3311 39.3438C10.2508 39.3438 2.0498 31.1428 2.0498 21.0625C2.0498 10.9822 10.2508 2.78125 20.3311 2.78125C30.4113 2.78125 38.6123 10.9822 38.6123 21.0625C38.6123 24.9396 37.4087 28.6459 35.1316 31.7809C33.9923 33.3503 32.619 34.7238 31.0496 35.8629ZM33.1803 36.7837C34.2315 35.9237 35.1924 34.9629 36.0522 33.9118L38.9336 36.7932C38.0574 37.8274 37.096 38.7889 36.0618 39.6651L33.1803 36.7837ZM49.392 50.1235C49.0081 50.5074 48.4982 50.7188 47.9561 50.7188C47.4139 50.7188 46.904 50.5074 46.5201 50.1235L37.5018 41.1052C38.5303 40.2226 39.4911 39.2619 40.3737 38.2334L49.3923 47.2519C49.776 47.6352 49.9873 48.145 49.9873 48.6875C49.9873 49.23 49.776 49.7398 49.392 50.1235Z",
    fill: "url(#paint1_linear_5543_13421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7127 16.7027C30.8381 14.4265 29.3154 12.4804 27.3089 11.0748C25.2547 9.6357 22.8418 8.875 20.3311 8.875C19.7702 8.875 19.3154 9.3298 19.3154 9.89062C19.3154 10.4515 19.7702 10.9062 20.3311 10.9062C24.5052 10.9062 28.317 13.5284 29.8166 17.4313C29.9718 17.8351 30.3566 18.083 30.7649 18.083C30.8859 18.083 31.0091 18.0611 31.1289 18.0151C31.6524 17.8139 31.9139 17.2264 31.7127 16.7027Z",
    fill: "url(#paint2_linear_5543_13421)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5543_13421",
    x1: 31.5029,
    y1: 20.0469,
    x2: 31.9834,
    y2: 22.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5543_13421",
    x1: 26.0186,
    y1: 0.75,
    x2: 38.3187,
    y2: 67.2802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5543_13421",
    x1: 25.548,
    y1: 8.875,
    x2: 27.1814,
    y2: 20.8355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5543_13421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.0185547 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/DiscoverIcon.d9d4aa803be4f8fd81de7b26d325778e.svg";
export { ForwardRef as ReactComponent };